{
  "messages": {
    "maximumInSizeOnlyOneImageTextZipOrSpreadsheetAllowedToUploadMultipleDocsZipFirstThenUpload": "Dung lượng tối đa {size}. Chỉ cho phép {imageLimit}, {typeLimitText}, {typeLimitZip} hoặc {typeLimitSpreadsheet}. Để tải lên nhiều tài liệu, hãy nén zip trước rồi tải lên.",
    "maximumInSizePerFileOnlyImageTextZipSpreadsheetAllowed": "Dung lượng tối đa {size} mỗi tệp. Tối đa {count} tệp. Chỉ cho phép {image}, {text}, {zip} hoặc {spreadsheet}.",
    "oneImage": "MỘT hình ảnh",
    "sizeInMegabytes": "{size} MB",
    "uploadDocument": "Tải lên tài liệu",
    "uploadDocuments": "Tải lên tài liệu"
  }
}
